import apiClient from './apiClient';
import { trackPromise } from 'react-promise-tracker';

async function listMachines(factoryCode) {
    const { data } = await trackPromise(apiClient.get(`/api/stats-public/machine/list/${factoryCode}`));
    return data?.data ?? [];
}

async function getPublicProductionBoard(machineId) {
    const { data } = await trackPromise(apiClient.get('/api/stats-public/production-board/' + machineId));
    return data;
}

async function getHeaderInfo(factoryCode) {
    const { data } = await trackPromise(apiClient.get(`/api/stats-public/header/${factoryCode}`));
    return data?.data;
}

async function getEnabledFactories() {
    const { data } = await trackPromise(apiClient.get(`/api/stats-public/factory/getAllEnabled`));
    return data?.data;
}

const publicService = {
    listMachines,
    getPublicProductionBoard,
    getHeaderInfo,
    getEnabledFactories
};

export default publicService;
